import { createSlice } from "@reduxjs/toolkit";
import { enqueueSnackbar } from 'notistack';

import { loadContactQuestions, responseContactQuestions } from '../thunks/contactQuestionsThunk'


export const contactQuestionsSlice = createSlice({
    name: 'contactQuestions',
    initialState:
    {
        itemsContactQuestions: [],
        selectedId: -1,
        selectedItem: null,
        openResponseContactQuestion: false
    },
    reducers:
    {
        selectItemById: (state, action) => {
            if (action.payload === null) {
                state.selectedId = -1;
                state.selectedItem = null;
            } else {
                state.selectedId = action.payload;
                state.selectedItem = state.itemsContactQuestions.find(
                    item => item.contactId === action.payload
                );
            }
        },
        showResponseContactQuestionModal: (state, action) => {
            state.openResponseContactQuestion = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadContactQuestions.fulfilled, (state, action) => {
                if (action.payload?.code === '00') {
                    state.itemsContactQuestions = action.payload?.metadata;
                    state.selectedId = -1;
                    state.selectedItem = null;
                }
                else{
                    state.itemsContactQuestions = [];
                    state.selectedId = -1;
                    state.selectedItem = null;
                    enqueueSnackbar(action.payload?.message, { variant: 'error', persist: false });
                }
            })
            .addCase(responseContactQuestions.fulfilled, (state, action) => {
                if (action.payload?.code === '00') {
                    state.itemsContactQuestions = state.itemsContactQuestions.map(item => (
                        item.contactId===action.payload?.metadata.contactId
                            ? {
                                ...item, 
                                answer: action.payload.metadata.answer,
                                status: action.payload.metadata.status,
                                statusName: action.payload.metadata.statusName,
                                statusColor: action.payload.metadata.statusColor,
                            }
                            : item
                    ));

                    state.selectedId = -1;
                    state.selectedItem = null;
                    state.openResponseContactQuestion = false;
                }
                else{
                    enqueueSnackbar(action.payload?.message, { variant: 'error', persist: false });
                }
            })
    }
})

export const { 
    selectItemById,
    showResponseContactQuestionModal
} = contactQuestionsSlice.actions;